// extracted by mini-css-extract-plugin
module.exports = {"header":"login_header__32k9M","settingsAlerter":"login_settingsAlerter__2vbK4"};